import { useClipboard } from '@chakra-ui/react';
import { useCallback } from 'react';
import { DropdownItem, useSnackbar } from 'ui-components';
import { ShareIcon } from 'ui-components/dist/ShareIcon';

interface IShareProfileDropdownItem {
  slug: string;
}

export const ShareProfileDropdownItem: React.FC<IShareProfileDropdownItem> = ({
  slug,
}) => {
  const snackbar = useSnackbar();

  const { onCopy } = useClipboard(`${slug}.foam.io`);
  const handleClickShareProfile = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onCopy();
      snackbar.success({ description: 'Creator link copied to clipboard' });
    },
    [onCopy, snackbar],
  );
  return (
    <DropdownItem aria-label="Share Creator" onClick={handleClickShareProfile}>
      <ShareIcon boxSize={4} />
      Share Profile
    </DropdownItem>
  );
};
